import React, { useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import './Team.css';

gsap.registerPlugin(ScrollTrigger);

function Team() {
  const sectionRef = useRef(null);
  const cardsRef = useRef([]);
  const navigate = useNavigate();

  const teamMembers = [
    {
      id: 2,
      name: 'Berke Palamutcu',
      role: 'Systems & IT',
      image: '/WebsitePhotos/Berke_Palamutcu.jpg',
      profilePath: '/berke',
      linkedin: 'https://www.linkedin.com/in/bspalamutcu/'
    },
    {
      id: 1,
      name: 'Miruna Spineanu',
      role: 'Product, Design & Engineering',
      image: '/WebsitePhotos/MirunaSpineanu.jpg',
      profilePath: '/mirunaspineanu',
      linkedin: 'https://www.linkedin.com/in/miruna-spineanu-935570338/',
      instagram: 'https://www.instagram.com/nix.nebula?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==',
      website: 'https://mirunadesign.com'
    }
  ];

  useEffect(() => {
    const section = sectionRef.current;
    if (!section) return;

    const cards = cardsRef.current.filter(Boolean);
    
    // Animate cards on scroll
    // eslint-disable-next-line react-hooks/exhaustive-deps
    cards.forEach((card, index) => {
      gsap.fromTo(card,
        {
          opacity: 0,
          y: 60,
          scale: 0.9
        },
        {
          opacity: 1,
          y: 0,
          scale: 1,
          duration: 0.8,
          delay: index * 0.15,
          ease: "power3.out",
          scrollTrigger: {
            trigger: card,
            start: "top 85%",
            toggleActions: "play none none reverse"
          }
        }
      );
    });

    // Cleanup
    return () => {
      ScrollTrigger.getAll().forEach(trigger => {
        if (trigger.trigger === section || cards.includes(trigger.trigger)) {
          trigger.kill();
        }
      });
    };
  }, []);

  return (
    <section ref={sectionRef} className="team-section scroll-fade-in" id="team">
      <span>meet our</span>
      <h2>Team</h2>
      <p>
        Reach out to the people actually building your product. No
        layers, no hand‑offs — just direct collaboration with the
        MythLabs crew.
      </p>
      <span className="bg-watermark">team</span>
      <div className="cards">
        {teamMembers.map((member, index) => (
          <div 
            key={member.id} 
            ref={el => cardsRef.current[index] = el}
            className="card"
            role="button"
            tabIndex={0}
            onClick={() => navigate(member.profilePath)}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                navigate(member.profilePath);
              }
            }}
          >
            <Link to={member.profilePath} className="card-image-link" onClick={(e) => e.stopPropagation()}>
              <img src={member.image} alt={member.name} />
            </Link>
            <div className="card-content">
              <h3>{member.name}</h3>
              <p>{member.role}</p>
              <ul>
                {member.linkedin && (
                  <li><a href={member.linkedin} target="_blank" rel="noopener noreferrer" onClick={(e) => e.stopPropagation()}><i className="fa-brands fa-linkedin-in"></i></a></li>
                )}
                {member.instagram && (
                  <li><a href={member.instagram} target="_blank" rel="noopener noreferrer" onClick={(e) => e.stopPropagation()}><i className="fa-brands fa-instagram"></i></a></li>
                )}
                {member.website && (
                  <li><a href={member.website} target="_blank" rel="noopener noreferrer" onClick={(e) => e.stopPropagation()}><i className="fa-solid fa-globe"></i></a></li>
                )}
              </ul>
              <Link to={member.profilePath} className="card-see-more-btn">
                See More
              </Link>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Team;

